var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartUtilities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 15,
    viewBox: "0 0 188 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.2717 7.43198C85.2717 12.0164 87.3317 14.3389 91.3708 14.3389C95.4099 14.3389 97.4699 12.0164 97.4699 7.43198L97.4901 0.100978H94.6425L94.6223 7.31081C94.6223 10.5421 93.7741 11.6932 91.3708 11.6932C88.9675 11.6932 88.1193 10.5421 88.1193 7.31081L88.1395 0.100978H85.2919L85.2717 7.43198Z",
    fill: "#28293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.19 2.72641V14.2379H107.017V2.72641H111.642V0.100978H99.565V2.72641H104.19Z",
    fill: "#28293D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.184 14.2379V0.100978H114.356V14.2379H117.184Z",
    fill: "#28293D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.591 14.2379V11.6125H124.199V0.100978H121.372V14.2379H131.591Z",
    fill: "#28293D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.004 14.2379V0.100978H134.176V14.2379H137.004Z",
    fill: "#28293D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.343 2.72641V14.2379H147.17V2.72641H151.795V0.100978H139.718V2.72641H144.343Z",
    fill: "#28293D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.337 14.2379V0.100978H154.509V14.2379H157.337Z",
    fill: "#28293D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.525 14.2379H172.128V11.6125H164.352V8.48215H171.582V5.85672H164.352V2.72641H171.865V0.100978H161.525V14.2379Z",
    fill: "#28293D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.525 14.3389C184.564 14.3389 186.422 12.2587 186.462 10.1988C186.523 7.61374 184.725 6.22024 180.646 5.67496C177.516 5.25085 177.677 4.36225 177.697 3.99873C177.778 2.90817 179.313 2.7466 180.242 2.7466C181.373 2.7668 182.847 3.00914 182.989 4.38245H185.917C185.776 1.73682 183.696 0.0201953 180.323 0C177.031 0 174.87 1.51467 174.688 3.95834C174.406 7.65413 178.788 8.28019 180.222 8.48215C182.06 8.74469 182.827 9.10821 183.15 9.39095C183.393 9.59291 183.514 9.87565 183.514 10.1988C183.514 11.5115 181.413 11.5721 180.525 11.5721C178.122 11.5721 177.394 10.4613 177.213 9.93623H174.103C174.325 13.1675 177.738 14.3389 180.525 14.3389Z",
    fill: "#28293D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42147 14.3389C10.4606 14.3389 12.3186 12.2587 12.359 10.1988C12.4196 7.61374 10.6221 6.22024 6.54264 5.67496C3.41232 5.25085 3.57389 4.36225 3.59408 3.99873C3.67487 2.90817 5.20973 2.7466 6.13873 2.7466C7.26968 2.7668 8.74396 3.00914 8.88533 4.38244H11.8137C11.6723 1.73682 9.59217 0.0201953 6.21951 0C2.92763 0 0.7667 1.51467 0.58494 3.95834C0.302201 7.65413 4.68465 8.28019 6.11853 8.48215C7.95633 8.74469 8.72376 9.10821 9.04689 9.39095C9.28924 9.59291 9.41041 9.87565 9.41041 10.1988C9.41041 11.5115 7.31007 11.5721 6.42147 11.5721C4.01819 11.5721 3.29115 10.4613 3.10939 9.93623H-0.000732422C0.221419 13.1675 3.63447 14.3389 6.42147 14.3389Z",
    fill: "#28293D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6169 14.2379V0.100978H27.9713L23.0435 9.73428L18.1158 0.100978H15.4702V14.2379H18.2976V6.76552L22.2761 14.2379H23.811L27.7895 6.76552V14.2379H30.6169Z",
    fill: "#28293D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8753 14.2379H35.7633L37.177 11.1682H43.7608L45.1744 14.2379H48.0422L41.4383 0.100978H39.4995L32.8753 14.2379ZM40.4689 4.01892L42.6298 8.7043H38.3079L40.4689 4.01892Z",
    fill: "#28293D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1172 0.100978V14.2379H52.9445V9.43134H55.8527L59.286 14.2379H62.598L58.882 8.98704C60.5987 8.32059 61.5882 6.82611 61.5882 4.76616C61.5882 0.706846 58.155 0.100978 56.095 0.100978H50.1172ZM56.0345 2.7466C58.2762 2.7466 58.7407 3.55442 58.7407 4.76616C58.7407 5.99809 58.2762 6.80591 56.0345 6.80591H52.9445V2.7466H56.0345Z",
    fill: "#28293D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3647 2.7264V14.2379H71.192V2.7264H75.8168V0.100978H63.7399V2.7264H68.3647Z",
    fill: "#28293D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartUtilities);
export default __webpack_public_path__ + "static/media/SmartUtilities.4248ab16e8666bf0aa632075dbfeaa60.svg";
export { ForwardRef as ReactComponent };